import type {
  BookingProvider,
  ExternalAccount,
} from "@/features/external-accounts/types";
import type { CheckedIntegration } from "./types";

/**
 * A booking software is an external account (backend
 * `calendars/services/external/booking-accounts.ts`): this is the same mapping
 * from the account's provider to the booking module's integration, and back.
 */
export const INTEGRATION_OF: Record<BookingProvider, CheckedIntegration> = {
  provalliance: "provalliance_backoffice",
  calendly: "calendly",
  website: "virtual_browser",
};

export const PROVIDER_OF: Record<CheckedIntegration, BookingProvider> = {
  provalliance_backoffice: "provalliance",
  calendly: "calendly",
  virtual_browser: "website",
};

/**
 * The configurator's fields an account stands for — everything but its secret,
 * which the page never holds: an edit leaves it empty to keep it.
 */
export const fieldsFromAccount = (
  account: ExternalAccount,
): Record<string, string> => {
  const settings = account.provider_settings || {};
  switch (account.provider) {
    case "provalliance":
      return {
        provalliance_public_url: account.server_url || "",
        provalliance_backoffice_url: settings.backoffice_url || "",
        provalliance_brand: settings.brand || "",
        provalliance_salon_id: settings.salon_id || "",
        provalliance_login: settings.login || account.provider_identifier,
      };
    case "website":
      return {
        virtual_browser_url: account.server_url || "",
        virtual_browser_login: settings.login || "",
      };
    default:
      return {};
  }
};
